export default "__VITE_ASSET__CZ2$hjiX__"